<template>
  <div>
    <el-table
      :data="list"
      show-summary
      :summary-method="getTotal"
      ref="multipleTable"
      tooltip-effect="dark"
      style="width: 100%"
      @selection-change="changeFun"
      v-loading=""
      @sort-change="changeSort"
    >
      <el-table-column
        type="selection"
        width="70px"
        v-if="sets.isShowSelect"
      ></el-table-column>
      <el-table-column
        label="序号"
        width="62px"
        type="index"
        v-if="sets.isShowIndex"
      ></el-table-column>
      <template v-for="col in tableHeader">
        <el-table-column
          v-if="
            col.dataItem.indexOf('sum') != -1 ||
              col.dataItem.indexOf('avg') != -1 ||
              col.dataItem.indexOf('sale') != -1
          "
          :show-overflow-tooltip="true"
          :prop="col.dataItem"
          :label="col.dataName"
          :key="col.dataItem"
          :min-width="col.width"
          sortable="custom"
        >
        </el-table-column>
        <el-table-column
          v-else
          :show-overflow-tooltip="true"
          :prop="col.dataItem"
          :label="col.dataName"
          :key="col.dataItem"
          :min-width="col.width"
        >
        </el-table-column>
      </template>
      <el-table-column
        label="操作"
        align="center"
        v-if="sets.isShowPlay"
        :width="sets.btnsWidth"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleAdd"
            type="success"
            plain
            title="添加设备"
            v-if="sets.isShowAddBtn"
          >添加
          </el-button>
          <el-button
            size="mini"
            @click="handleLook(scope)"
            type="primary"
            plain
            title="销售报表"
            v-if="sets.isShowEditBtn"
          >销售报表
          </el-button>
          <el-button
            size="mini"
            @click="handleInfo(scope.$index, scope.row)"
            type="primary"
            plain
            title="资产详情"
            v-if="sets.isShowAssetsDetailBtn"
          >资产详情
          </el-button>
          <el-button
            size="mini"
            @click="handleInfo(scope.$index, scope.row)"
            type="info"
            plain
            title="销售详情"
            v-if="sets.isShowInfoBtn"
          >销售详情
          </el-button>
          <el-button
            size="mini"
            @click="handleAssets(scope.$index, scope.row)"
            type="info"
            plain
            title="设备详情"
            v-if="sets.isShowAssetsBtn"
          >设备详情
          </el-button>
          <el-button
            size="mini"
            @click="handleDelete(scope.$index, scope.row)"
            type="danger"
            plain
            title="删除"
            v-if="sets.isShowDelBtn"
          >删除
          </el-button>
          <el-button
            size="mini"
            @click="handleGoods(scope.$index, scope.row)"
            type="info"
            plain
            title="柜内监控"
            v-if="sets.isshowGoodsBtn"
          >柜内监控
          </el-button>
          <el-button
            size="mini"
            @click="handleGoodsRanks(scope.$index, scope.row)"
            type="info"
            plain
            title="设备销量排行"
            v-if="sets.isShowGoodsRanks"
          >设备销量排行
          </el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  name: 'ReportBasic',
  props: {
    setting: Object,
    list: Array,
    date: Array
  },
  data () {
    return {
      sets: this.setting,
      tableHeader:
        this.setting.tHeader && this.setting.tHeader.length > 0
          ? this.setting.tHeader
          : [],
      dater: this.date
    }
  },
  mounted () {
    // console.log(this.list)
    // console.log(this.dater)
  },
  methods: {
    handleAssets (index, row) {
      var urls = 'data/getAssetsManagementList'
      this.$router.push({
        name: 'devicesStart',
        params: {
          channelType: row.channelType ? row.channelType : '',
          url: urls,
          date: this.dater ? this.dater : '',
          groupName: row.groupName ? row.groupName : '',
          assets: row.assets
        }
      })
    },
    handleInfo (index, row) {
      var urls = 'data/getDataReport_SalesDetailList'
      if (this.$route.path == '/devices') {
        urls = 'data/getAssetsManagementList'
      }
      if (this.$route.path == '/classRep') {
        urls = 'data/getDataReportClassifySalesDetail'
      }

      let routeData = this.$router.resolve({
        path: this.sets.infoUrl,
        query: {
          groupId: row.groupId ? row.groupId : '',
          assetsNum: row.assetsNum ? row.assetsNum : '',
          channelType: row.channelType ? row.channelType : '',
          secondChannelType: row.secondChannelType ? row.secondChannelType : '',
          thirdChannelType: row.thirdChannelType ? row.thirdChannelType : '',
          date: this.dater,
          cityCode: row.cityCode ? row.cityCode : '',
          provinceCode: row.provinceCode ? row.provinceCode : '',

          areaCompanyId: row.areaCompanyId ? row.areaCompanyId : '',
          provinceBranchCompanyId: row.provinceBranchCompanyId
            ? row.provinceBranchCompanyId
            : '',
          groupName: row.groupName ? row.groupName : '',
          url: urls
        }
      })
      window.open(routeData.href, '_blank')
    },
    handleGoods (index, row) {
      var inforUrl = this.sets.infoUrl
      if (inforUrl == 'deviceDetail') {
        inforUrl = 'devicesImages'
      }
      var urls = 'data/getMetadataImageList'
      let routeData = this.$router.resolve({
        name: inforUrl,
        query: {
          assetsNum: row.assetsNum ? row.assetsNum : '',
          url: urls
        }
      })
      window.open(routeData.href, '_blank')
    },
    handleGoodsRanks (index, row) {
      var urls = 'data/getGoodsRanksList'
      let routeData = this.$router.resolve({
        name: this.sets.infoUrl,
        query: {
          goodsNum: row.goodsNum ? row.goodsNum : '',
          goodsName: row.goodsName ? row.goodsName : '',
          date: this.dater ? this.dater : '',
          url: urls
        }
      })
      window.open(routeData.href, '_blank')
    },
    handleDelete (index, row) {
      if (this.$route.path == '/devices') {
        var msg = '是否删除分组 [' + row.groupName + '] ?'
        var params = {
          groupId: row.groupId
        }
        var url = 'data/deleteGroup'
      } else if (this.$route.path == '/devicesDetail') {
        var msg = '是否删除设备 [' + row.assetsNum + '] ?'
        // console.log(row)
        var params = {
          groupId: row.groupId,
          assetsNums: row.assetsNum
        }
        var url = 'data/deleteGroupRelative'
      }
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$ajax
            .post(url, params)
            .then(res => {
              if (res.data.code == 200) {
                this.$message({
                  message: '已删除',
                  type: 'success'
                })
                this.$emit('freshList')
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch(err => {
              this.$message.error('请求失败')
            })
        })
        .catch(() => {})
    },
    handleAdd () {
      this.$router.push({ name: 'devicesStart', params: {} })
    },
    handleLook (scope) {
      // console.log(scope.row.groupId)
      var urls = 'data/getDataReport_SalesDetailList'
      let routeData = this.$router.resolve({
        name: 'reportsDetail',
        query: {
          groupId: scope.row.groupId,
          url: urls
        }
      })
      window.open(routeData.href, '_blank')
    },
    changeFun () {
      this.$emit('callFather', this.$refs.multipleTable.selection)
    },
    getTotal (param) {
      console.log(param, '================')
      const { columns, data } = param
      const sums = []
      let deviceTotal = null
      let deviceValues = data.map(item => Number(item['putAssetsNum']))
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        // if (index === 1) {
        //     sums[index] = '';
        //     return;
        // }
        const values = data.map(item => Number(item[column.property]))
        if (!values.every(value => isNaN(value))) {
          if (column.property.indexOf('avg') !== -1) {
            sums[index] = 0
            for (let i = 0; i < values.length; ++i) {
              let value = values[i]
              if (!isNaN(value)) {
                sums[index] = Number(value * deviceValues[i]) + sums[index]
              }
            }
          } else {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              prev = Number(prev)
              if (!isNaN(value)) {
                var num = new Number(prev + curr)
                return num.toFixed(2)
              } else {
                return new Number(prev)
              }
            }, 0)
          }
          if (index === 2) {
            deviceTotal = sums[index]
          }
          if (sums[index] === 0) {
            sums[index] = ''
          } else {
            if (deviceTotal && column.property.indexOf('avg') !== -1) {
              sums[index] = (Number(sums[index]) / deviceTotal).toFixed(2)
            }
          }
        } else {
          sums[index] = ''
        }
      })
      // 对数据做个性化处理
      for (let i = 0; i < sums.length; i++) {
        if (i === 2 || i === 3 || i === 4 || i === 6 || i === 7) {
          sums[i] = Math.round(sums[i])
        }
      }
      return sums
    },
    changeSort (val) {
      this.$emit('changeSort', val)
    }
  }
}
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/reportsBasic.vue